'use client';

// MUST be first import - sets up network interception before any other modules load
import '@/server/networkService';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { initializeAudio } from '@/utils/audio';
import { LevaStyles } from '@/site/LevaStyles/LevaStyles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
    },
  },
});

export const Providers = ({ children }: { children: React.ReactNode }) => {
  useEffect(initializeAudio, []);

  return (
    <QueryClientProvider client={queryClient}>
      <LevaStyles>{children}</LevaStyles>
    </QueryClientProvider>
  );
};
